import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { format} from 'date-fns';
import { ModalService } from 'src/app/services/modal.service';
import { createSeasonLeague, updateSeasonLeague } from 'src/app/store/actions/tournament.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-update-league',
  templateUrl: './update-league.component.html',
  styleUrls: ['./update-league.component.scss']
})
export class UpdateLeagueComponent implements OnInit {

  season!: any;
  league!: any;

  form: FormGroup;

  constructor(
    private modalService: ModalService,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    console.log(this.league);
    
    this.form = this.fb.group({
      name:  ['', new FormControl()],
      leagueStart:  ['', new FormControl()],
      leagueEnd:  ['', new FormControl()],
      leagueDeadline:  ['', new FormControl()],
      leagueOpen:  ['', new FormControl()],
      ratingMinimum:  ['', new FormControl()],
      ratingMaximum:  ['', new FormControl()],
      players:  ['', new FormControl()],
      leagueCategory:  ['', new FormControl()],
      leagueType:  ['', new FormControl()],
      leagueRound: ['', new FormControl()],
    });

    this.form.patchValue({
      name: this.league?.name,
      leagueStart: this.league?.leagueStart,
      leagueEnd: this.league?.leagueEnd,
      leagueDeadline: this.league?.leagueDeadline,
      leagueOpen: this.league?.leagueOpen,
      ratingMinimum: this.league?.ratingMinimum,
      ratingMaximum: this.league?.ratingMaximum,
      players: this.league?.players.toString(),
      leagueCategory: this.league?.leagueCategory,
      leagueType: this.league?.leagueType,
      leagueRound: this.league?.leagueRound,
    })
  }

  createSeasonLeague(){
    const startValue = this.leagueStart?.value;
    const endValue = this.leagueEnd?.value;
    const deadlineValue = this.leagueDeadline?.value;

    const startDate = new Date(startValue);
    const endDate = new Date(endValue);
    const deadline = new Date(deadlineValue);
    
    if (endDate < startDate) {
      console.error("Invalid End Date: Must be after or equal to Start Date");
      return;
    }

    const payload = {
      leagueId: this.league.leagueId,
      seasonId: this.season.seasonId,
      name: this.name?.value,
      leagueStart: format(new Date(this.leagueStart?.value), 'yyyy-MM-dd'),
      leagueEnd: format(new Date(this.leagueEnd?.value), 'yyyy-MM-dd'),
      leagueDeadline: format(new Date(this.leagueDeadline?.value), 'yyyy-MM-dd'),
      leagueOpen: this.leagueOpen?.value,
      ratingMinimum: this.ratingMinimum?.value,
      ratingMaximum: this.ratingMaximum?.value,
      players: this.players?.value,
      leagueCategory: this.leagueCategory?.value,
      leagueType: this.leagueType?.value,
      leagueRound: this.leagueRound?.value,
    }

    this.modalService.showLoadingSpinner();
    this.store.dispatch(updateSeasonLeague({data: payload}));
  }

  get name(){
    return this.form.get('name');
  }

  get status(){
    return this.form.get('status');
  }

  get leagueStart(){
    return this.form.get('leagueStart');
  }

  get leagueEnd(){
    return this.form.get('leagueEnd');
  }

  get leagueDeadline(){
    return this.form.get('leagueDeadline');
  }

  get leagueOpen(){
    return this.form.get('leagueOpen');
  }

  get ratingMinimum(){
    return this.form.get('ratingMinimum');
  }

  get ratingMaximum(){
    return this.form.get('ratingMaximum');
  }

  get players(){
    return this.form.get('players');
  }

  get leagueCategory(){
    return this.form.get('leagueCategory');
  }

  get leagueType(){
    return this.form.get('leagueType');
  }

  get leagueRound(){
    return this.form.get('leagueRound');
  }

  close(){
    this.modalService.hideUpdateSeasonLeague();
  }

  dateToday = new Date(); 

}
